import { useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  DeleteButton,
  ExportButton,
  FormButton,
  copy,
  deletionAlert,
  exportToExcel,
  exportToPDF,
  getAuthorities,
  noRecordsAlert,
  print,
  redirectToPages,
  resultAlert
} from "../../../../../_helpers/Helpers";
import * as actions from "../../_redux/activity-types/ActivityTypesAction";
import { 
  Card, 
  CardBody, 
  CardHeader,
  CardHeaderToolbar,
  ModalProgressBar
} from "../../../../../_metronic/_partials/controls";
import { useActivityTypesUIContext } from "./ActivityTypesUIContext";
import { ActivityTypesFilter } from "./activity-types-filter/ActivityTypesFilter";
import { ActivityTypesTable } from "./activity-types-table/ActivityTypesTable";

export function ActivityTypesCard() {
  // ActivityTypes UI Context
  const activityTypesUIContext = useActivityTypesUIContext();
  const activityTypesUIProps = useMemo(() => {
    return {
      ids: activityTypesUIContext.ids,
      setIds: activityTypesUIContext.setIds,
      queryParams: activityTypesUIContext.queryParams,
      openNewActivityTypePage: activityTypesUIContext.openNewActivityTypePage,
    };
  }, [activityTypesUIContext]);

  // Getting curret state of Activity Type list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.activityTypes }),
    shallowEqual
  );
  const { actionsLoading, isSuccess, type, authorities } = currentState;

  // Authority Parameters
  const { isExportationAuthorized, isAdditionAuthorized, isDeletionAuthorized } = getAuthorities(authorities);
  
  // ActivityTypes Redux state
  const dispatch = useDispatch();

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);
  
  /** Belli Bir Faaliyet Türü Listesini Excele Aktarır */
  const exportActivityTypesToExcel = () => {
    dispatch(actions.getAllActivityTypes(activityTypesUIProps.queryParams)).then(entities => {
      if (entities.isSuccess === false) return;
      const rows = [];
      const widths = [30];
      const columns = ["Adı"];
      entities.forEach(entity => rows.push([entity.name]));
      const filename = "Faaliyet Türü Listesi";
      exportToExcel({ columns, rows, widths, filename });
    });
  }

  /** Belli Bir Faaliyet Listesini PDF e Aktarır */
  const exportActivityTypesToPDF = () => {
    dispatch(actions.getAllActivityTypes(activityTypesUIProps.queryParams)).then(entities => {
      if (entities.isSuccess === false) return;
      const views = [ 
        {
          header: "Adı",
          rows: entities.map(entity => entity.name)
        }
      ];
  
      const filename = "Faaliyet Türü Listesi";
      exportToPDF(views, filename);
    });
  }

  /** Belli Bir Faaliyet Türü Listesini Yazdırma Penceresini Açar */
  const printActivityTypes = () => {
    dispatch(actions.getAllActivityTypes(activityTypesUIProps.queryParams)).then(entities => {
      if (entities.isSuccess === false) return;
      const data = [];    
      const header = "Faaliyet Türü Listesi";
      const properties = ["Adı"];

      entities.forEach(entity => {
        data.push({
          "Adı": entity.name
        });
      });

      print({ data, properties, header });
    });
  }

  /** Belli Bir Faaliyet Türü Listesini Panoya Kopyalar */
  const copyActivityTypes = () => {
    dispatch(actions.getAllActivityTypes(activityTypesUIProps.queryParams)).then(entities => {
      if (entities.isSuccess === false) return;
      const rows = [];
      const header = "Faaliyet Türü Listesi";
      const columns = ["Adı"];
      entities.forEach(entity => rows.push([entity.name]));
      copy({ header, columns, rows });
    });
  }

  /** Belli Bir Faaliyet Türü Listesini Siler */
  const deleteActivityTypes = (ids) => {
    if (typeof ids === 'string') ids = ids.split(",");
  
    if (ids.length < 1) {
      noRecordsAlert();
      return;
    }  
    deletionAlert().then(result => {
      if (result.isConfirmed) dispatch(actions.deleteActivityTypes(ids)).then(result => onResult(result));
    });
  }

  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);

    if (isSuccess) {
      setTimeout(() => {
        activityTypesUIProps.setIds([]);
        dispatch(actions.getActivityTypes(activityTypesUIProps.queryParams));
      }, 2500);
    }
  };
  
  const title = <>Faaliyet Türü Listesi{activityTypesUIProps.ids.length > 0 ?
                  <> [Seçilen Kayıt Sayısı: <span style={{color:"red"}}>{activityTypesUIProps.ids.length}</span>]</> : ""}
                </>;

  return (
    <Card>
      {actionsLoading && <ModalProgressBar />}
      <CardHeader title={title}>
        {
          (isExportationAuthorized || isAdditionAuthorized || isDeletionAuthorized) &&
          <CardHeaderToolbar>
            {
              isExportationAuthorized &&
              <ExportButton
                exportToExcel={exportActivityTypesToExcel}
                exportToPDF={exportActivityTypesToPDF}
                print={printActivityTypes}
                copy={copyActivityTypes}
              />
            }
            {
              isAdditionAuthorized &&
              <FormButton
                path="Navigation/Plus"
                title="Yeni Faaliyet Türü"
                method={activityTypesUIProps.openNewActivityTypePage}
              />
            }              
            {
              isDeletionAuthorized && 
              <DeleteButton 
                title="Seçilenleri Sil"
                method={() => deleteActivityTypes(activityTypesUIProps.ids)}
              />
            }
          </CardHeaderToolbar>
        }        
      </CardHeader>
      <CardBody>
        <ActivityTypesFilter />
        <ActivityTypesTable
          deleteActivityTypes={deleteActivityTypes}
        />
      </CardBody>
    </Card>
  );
}